import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
export default {
  name: "promote-list",
  data: function data() {
    return {
      searchForm: {
        pn: 1,
        ps: 20,
        id: ""
      },
      // 搜索表单

      filterList: [],
      districtList: [],
      tableLoading: false,
      tableData: [],
      // 表格数据
      total: 0 // 总数
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.getData();
            _this.getHouseFilterType();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    batchStick: function batchStick() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var ids;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              ids = [];
              _this2.tableData.forEach(function (item) {
                if (item.status == 3) {
                  ids.push(item.houseId);
                }
              });
              _this2.$confirm("\u6279\u91CF\u7F6E\u9876".concat(ids.length, "\u6761\u63A8\u5E7F\u4E2D\u623F\u6E90"), "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
              }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
                return _regenerator().w(function (_context2) {
                  while (1) switch (_context2.n) {
                    case 0:
                      _this2.stickHouse(ids);
                    case 1:
                      return _context2.a(2);
                  }
                }, _callee2);
              }))).catch(function () {});
            case 1:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    stickHouse: function stickHouse(id) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return _this3.$api.stickHouse({
                houseId: id
              });
            case 1:
              _this3.$message.success("操作成功");
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    updatePromoteStatus: function updatePromoteStatus(row, status) {
      var _this4 = this;
      if (row.houseStatus != 4 && status == 1) {
        this.$message.error("该房源不是在线状态，请处理后再开始推广");
        return;
      }
      var title = status == 1 ? "设置为推广开始， 是否继续?" : "设置为不通过， 是否继续?";
      this.$confirm(title, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return _this4.$api.updatePromoteStatus({
                id: row.id,
                status: status
              });
            case 1:
              if (status == 1) {
                _this4.$message.success("该房源已推广");
              } else {
                _this4.$message.success("操作成功");
              }
              _this4.getData();
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))).catch(function () {});
    },
    pageChange: function pageChange(pn) {
      this.searchForm.pn = pn;
      this.getData();
    },
    getData: function getData(type) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var res;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              if (type === "search") {
                _this5.searchForm.pn = 1;
              }
              _this5.tableLoading = true;
              _context6.n = 1;
              return _this5.$api.getPromoteList(_this5.searchForm);
            case 1:
              res = _context6.v;
              _this5.tableData = res.data.list;
              _this5.total = res.data.count;
              _this5.tableLoading = false;
            case 2:
              return _context6.a(2);
          }
        }, _callee6);
      }))();
    },
    getHouseFilterType: function getHouseFilterType() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var res;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              _context7.n = 1;
              return _this6.$api.getHouseFilterType();
            case 1:
              res = _context7.v;
              _this6.filterList = res.data;
            case 2:
              return _context7.a(2);
          }
        }, _callee7);
      }))();
    },
    getDistrictList: function getDistrictList(val) {
      var _this7 = this;
      if (val) {
        this.filterList.cityList.forEach(function (value) {
          if (value.id === val) {
            _this7.searchForm.districtId = "";
            _this7.districtList = value.item;
          }
        });
      } else {
        this.districtList = [];
      }
    }
  }
};